document.addEventListener("DOMContentLoaded", () => {
  const subtitles = document.querySelectorAll(".footer__subtitle");

  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  subtitles.forEach(subtitle => {
    subtitle.addEventListener("click", () => {
      if (isMobile()) {
        subtitle.closest(".footer__minicol")?.classList.toggle("is-open");
      }
    });
  });
});
